import { ApiError, type ClaimEdgeDeviceInput, type SitePickupLocation } from "@lumora/bridge";

const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** Returns a lowercase valid site slug, or null. */
export function normalizeSlug(raw: string): string | null {
  const s = raw.trim().toLowerCase();
  return slugPattern.test(s) ? s : null;
}

export interface LocationOption {
  value: string;
  label: string;
}

/** Enabled pickup locations only; blank value (primary) is added by the UI. */
export function pickupLocationOptions(locations: SitePickupLocation[] | undefined): LocationOption[] {
  return (locations ?? []).filter((l) => l.enabled).map((l) => ({ value: l.slug, label: l.name }));
}

export function buildClaimInput(f: {
  code: string;
  name: string;
  locationId: string;
}): ClaimEdgeDeviceInput {
  const input: ClaimEdgeDeviceInput = {
    code: f.code.replace(/\s/g, "").toUpperCase(),
    name: f.name.trim() || "Kitchen Pi",
  };
  if (f.locationId.trim()) input.locationId = f.locationId.trim();
  return input;
}

/** Clear text for a failed claim; 429 `rate_limited` gets its own message (#1015). */
export function claimErrorText(err: unknown): string {
  if (err instanceof ApiError && err.status === 429 && err.code === "rate_limited") {
    return "Too many pairing attempts. Wait a minute and try again.";
  }
  return err instanceof Error ? err.message : "Could not pair this device.";
}
